import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { BaseComponent, UserService, ContentService, environment } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-account-plan-fsp-upsell",
  templateUrl: "./plan-fsp-upsell.component.html",
  standalone: false,
})
export class AccountPlanFspUpsellComponent extends BaseComponent implements OnInit {
  @Input() upsellMessage: string;
  @Input() upsellHeader: string;

  public upsellBenefitKeys = ["complete_software_suite", "content_libraries", "cloud_storage", "collaboration_tools", "expert_access", "exclusive_perks"];

  constructor(
    public userService: UserService,
    public appService: AppService,
    public contentService: ContentService,
    private _router: Router,
    public translate: TranslateService
  ) {
    super(userService);
  }

  ngOnInit() {
    if (!this.upsellHeader) {
      this.upsellHeader = this.translate.instant("account.plan_fsp_upsell.header");
    }
  }

  upgrade() {
    this._router.navigate(["/onboarding"], { queryParams: { subscribeOnly: true } });
  }

  learnMoreAboutFspPlus() {
    this.appService.showVideo(environment.fspPlusLearnMoreVideoId);
  }
}
